// Production stand-in for src/local/boot.js — deliberately inert. The on-premise
// build mints an install id, asks for storage persistence and checks its licence
// here; a cloud build has none of those concepts.
export const getInstallId = () => null;
export const getPersistence = () => ({ supported: false, persisted: false });
export async function startLocalSession() {
  return null;
}

// Answers rather than throwing: App.vue calls this on sign-in and on focus in
// every build. A cloud build has no licence cache and no deployment move to
// notice, so there is nothing to refresh.
export async function refreshLicence() {
  return null;
}
